import './components/jquery';
import './components/mask';
import './components/menu-nav';
import './components/lgpd';
import './components/rangeInputs';
import './components/swiper';
import './components/wow-init';
import './components/facilities';
import './components/video';
import './components/swiper';
import './components/methodology-details';
import './components/modal';
import './components/units';
import './components/faq';
import './components/form';
import './components/see-more';
import './components/title-dot';